'use client';

import { createContext, useContext, useEffect, useState } from "react";

export const StripeContext = createContext({
    stripe: null,
    customerId: null,
    clientSecret: null,
    pricePerMonth: null,
    branchLink: null,
    userId: null,
});

export const StripeContextProvider = ({
    customerId,
    clientSecret,
    pricePerMonth,
    branchLink,
    userId,
    children,
    withTrial = true,
    priceAmount,
    isNewFlow = false,
    monthlyTrialEnd,
    annualTrialEnd,
    monthlySubscriptionId,
    annualSubscriptionId,
    userEmail,
    monthlyClientSecret,
    annualClientSecret,
    prices,
    subscriptionId,
    interval,
    trialEnd,
    couponId,
    discounts
}) => {
    const [stripeData, setStripeData] = useState({
        customerId,
        clientSecret,
        pricePerMonth,
        branchLink,
        userId,
        withTrial,
        priceAmount,
        isNewFlow,
        monthlyTrialEnd,
        annualTrialEnd,
        monthlySubscriptionId,
        annualSubscriptionId,
        userEmail,
        monthlyClientSecret,
        annualClientSecret,
        prices,
        subscriptionId,
        interval,
        trialEnd,
        couponId,
        discounts
    });

    useEffect(() => {
        setStripeData(existingData => ({
            ...existingData,
            customerId,
            clientSecret,
            pricePerMonth,
            branchLink,
            userId,
            withTrial,
            priceAmount,
            isNewFlow,
            monthlyTrialEnd,
            annualTrialEnd,
            monthlySubscriptionId,
            annualSubscriptionId,
            userEmail,
            monthlyClientSecret,
            annualClientSecret,
            prices,
            subscriptionId,
            interval,
            trialEnd,
            couponId,
            discounts
        }));
    }, [
        customerId,
        clientSecret,
        pricePerMonth,
        branchLink,
        userId,
        withTrial,
        priceAmount,
        isNewFlow,
        monthlyTrialEnd,
        annualTrialEnd,
        monthlySubscriptionId,
        annualSubscriptionId,
        userEmail,
        monthlyClientSecret,
        annualClientSecret,
        prices,
        subscriptionId,
        interval,
        trialEnd,
        couponId
    ]);

    return (
        <StripeContext.Provider value={{
            stripeData,
            setStripeData: data => {
                setStripeData({
                    ...stripeData,
                    ...data,
                });
            },
        }}>
            {children}
        </StripeContext.Provider>
    );
};

export const useStripeContext = () => {
    const context = useContext(StripeContext);
    if (!context) {
        throw new Error('useStripeContext must be used within a StripeContextProvider');
    }
    return context;
};
